// frontend/src/components/common/EmptyState.tsx
// Centered "nothing here yet" block with icon, title, description, and optional CTAs.
// Shared across pages so every empty table looks the same.

import React from "react";

interface EmptyStateAction {
  label: string;
  icon?: React.ReactNode;
  onClick: () => void;
}

interface EmptyStateProps {
  icon: React.ReactNode;
  title: string;
  description?: string;
  action?: EmptyStateAction;
  secondaryAction?: EmptyStateAction;
  fontFamily?: string;
  color?: string;
}

export default function EmptyState({
  icon,
  title,
  description,
  action,
  secondaryAction,
  fontFamily,
  color = "#12262B",
}: EmptyStateProps): React.ReactElement {
  const hasAction = Boolean(action || secondaryAction);
  return (
    <div style={{ padding: "60px 20px", textAlign: "center", fontFamily }}>
      <div style={{ color, opacity: 0.4, marginBottom: 12, display: "inline-flex" }}>
        {icon}
      </div>

      <div style={{ fontSize: 18, fontWeight: 700, color, marginBottom: 6 }}>
        {title}
      </div>

      {description && (
        <div
          style={{
            fontSize: 14,
            color,
            maxWidth: 400,
            margin: hasAction ? "0 auto 16px" : "0 auto",
          }}
        >
          {description}
        </div>
      )}

      {hasAction && (
        <div style={{ display: "inline-flex", gap: 10, alignItems: "center" }}>
          {secondaryAction && (
            <button
              onClick={secondaryAction.onClick}
              style={{
                padding: "12px 20px",
                background: "#fff",
                border: "1px solid #D8DEE6",
                borderRadius: 10,
                color: "#2A3838",
                fontSize: 14,
                fontWeight: 600,
                cursor: "pointer",
                fontFamily: fontFamily || "inherit",
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              {secondaryAction.icon}
              {secondaryAction.label}
            </button>
          )}
          {action && (
            <button
              onClick={action.onClick}
              style={{
                padding: "12px 20px",
                background: "#0E1A1A",
                border: "none",
                borderRadius: 10,
                color: "#fff",
                fontSize: 14,
                fontWeight: 700,
                cursor: "pointer",
                fontFamily: fontFamily || "inherit",
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              {action.icon}
              {action.label}
            </button>
          )}
        </div>
      )}
    </div>
  );
}